export const DATA_ATLAS_PATH = '/data_atlas';

export const ATLAS_DISPLAY_MODES = {
	CLOSED: 'closed',
	FLOATING: 'floating',
	DOCKED: 'docked'
};

export const ATLAS_DOCK_WIDTH_CSS_VAR = '--atlas-dock-width';

export const ATLAS_FLOATING_DEFAULT_WIDTH = 780;
export const ATLAS_FLOATING_DEFAULT_HEIGHT = 600;
export const ATLAS_DEFAULT_DOCK_WIDTH = 480;

export const getAtlasWelcomeStorageKey = (userId) => `atlas_welcome_dismissed:${userId}`;

export const readAtlasWelcomeDismissed = (userId, storage = globalThis.localStorage) => {
	try {
		return storage.getItem(getAtlasWelcomeStorageKey(userId)) === '1';
	} catch {
		return false;
	}
};

export const writeAtlasWelcomeDismissed = (userId, storage = globalThis.localStorage) => {
	try {
		storage.setItem(getAtlasWelcomeStorageKey(userId), '1');
	} catch {
		// localStorage may be unavailable
	}
};

export const buildAtlasReferralUrl = (rawUrl, mode) => {
	if (!rawUrl) {
		return null;
	}
	const separator = rawUrl.includes('?') ? '&' : '?';
	return `${rawUrl}${separator}mode=${mode}`;
};

export const shouldShowAtlasHelper = ({ pathname, authUser }) => {
	if (!authUser.canAccessDataExplorer) {
		return false;
	}
	const path = pathname || '';
	if (path === DATA_ATLAS_PATH || path.startsWith(`${DATA_ATLAS_PATH}/`)) {
		return false;
	}
	return true;
};

export const getAtlasFloatingBounds = (viewport) => ({
	gutter: 12,
	minWidth: 400,
	minHeight: 320,
	maxWidth: viewport.width - 24,
	maxHeight: viewport.height - 24,
	viewport
});

export const getAtlasDockBounds = (viewport) => ({
	gutter: 12,
	minWidth: 320,
	maxWidth: Math.floor(viewport.width * 0.7),
	viewport
});

export const getAtlasFloatingDefaultGeometry = (viewport) => {
	const width = Math.min(ATLAS_FLOATING_DEFAULT_WIDTH, viewport.width - 48);
	const height = Math.min(ATLAS_FLOATING_DEFAULT_HEIGHT, viewport.height - 120);
	return {
		width,
		height,
		x: Math.max(12, viewport.width - width - 18),
		y: Math.max(12, viewport.height - height - 64 - 18)
	};
};

export const getAtlasFloatingExpandedGeometry = (viewport) => {
	const width = Math.min(viewport.width - 120, viewport.width - 24);
	const height = Math.min(viewport.height - 160, viewport.height - 24);
	return {
		width,
		height,
		x: Math.max(12, viewport.width - width - 18),
		y: Math.max(12, (viewport.height - height) / 2)
	};
};

export const getAtlasExpandWindowControl = (windowExpanded) => (
	windowExpanded
		? { ariaLabel: 'Collapse window', tip: 'Collapse window' }
		: { ariaLabel: 'Expand window', tip: 'Expand window' }
);

export const setAtlasDockLayoutCssVar = (dockWidth, doc = document) => {
	if (!doc?.documentElement) {
		return;
	}
	const value = dockWidth > 0 ? `${dockWidth}px` : '0px';
	doc.documentElement.style.setProperty(ATLAS_DOCK_WIDTH_CSS_VAR, value);
};

export const clearAtlasDockLayoutCssVar = (doc = document) => {
	setAtlasDockLayoutCssVar(0, doc);
};
